import { launchChat } from '../../utils/sf-utils/chat-actions';
import { t } from '../../utils/app-utils/translations';
import { getCACustomButtonElement, updateFloatingButtonText } from '../../utils/button-utils/custom-button-utils';
import { conflictingPageMapping } from '../../context/page-mapping';
import { addConflictingPageCSSClass, isPageConflicting } from '../../utils/button-utils/helper';
import { handleFilters } from '../../utils/button-utils/discovery-page';
import { handleProductPages } from '../../utils/button-utils/product-page-utils';
import { isChatActive } from '../../../utils/chat-utils';

import './ca-styles.scss';
import './ca-button-position-styles.scss';
import { logNR } from '../../utils/app-utils/nr-logging';
import { trackEvent } from '../../utils/app-utils/event-utils';

export const caButton = () => `
  <button 
    type="button" 
    class="swan-button 
          swan-button-skin-primary 
          swan-button-with-icon-left 
          swan-compact-mode 
          caHelpButtonEnabled 
          hideCTAbutton"
    id="caHelpButton"
  >
    <img
      src="https://swan.prod.merch.vpsvc.com/v3/icons/live_chat.0c91b22f94451864870cbcfb132e04d6.svg"
      alt="image"
      class="swan-icon 
            swan-icon-mask 
            swan-icon-size-standard 
            swan-icon-skin-standard 
            swan-icon-type-image 
            caHelpIconBg"
      id="caButtonIcon"
    />
    <div id="caButtonText" >
    ${t('ca-message')}
    </div>
    <span class="messageCount" id="caButtonMessageCount"></span>
  </button>`;

const addSkipLinkBtn = () => {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      setTimeout(() => {
        const chatBtn = document.getElementById('caHelpButton');
        const skipLinkContainer = document.querySelector('[href="#maincontentstart"]')?.parentElement;

        if (chatBtn && skipLinkContainer && !document.getElementById('skipToChatLink')) {
          const skipToChat = document.createElement('a');
          skipToChat.id = 'skipToChatLink';
          skipToChat.className = 'swan-skip-link';
          skipToChat.style.zIndex = '10000';
          skipToChat.href = '#chatbtn';
          skipToChat.textContent = 'Skip to Chat';

          skipToChat.addEventListener('click', (event) => {
            event.preventDefault();
            chatBtn.focus();
          });

          skipLinkContainer.appendChild(skipToChat);
          skipToChat.focus();
        }
      }, 0);
    }
  });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createFloatingButton = async (context: any, showButton = true) => {
  /** Create Root element which will contain the chat button and add it to the page */
  const root = document.createElement('div');
  root.setAttribute('id', 'caRootDiv');
  root.setAttribute('class', 'swan');
  if (document.getElementById('caRootDiv') === null) document.body.appendChild(root);
  root.innerHTML = caButton();

  const customButton = getCACustomButtonElement();

  /** Make the button visible if showButton True */
  if (showButton) {
    customButton?.classList.remove('hideCTAbutton');
  }

  /** If the page has conflicting CSS initially, add the class */
  if (isPageConflicting()) {
    conflictingPageMapping.forEach((ele) => {
      addConflictingPageCSSClass(customButton, ele.pageName, ele.className);
    });
  }

  /** To Hide chat button when filters are opened */
  handleFilters();

  /** To Change the position of the chat button for product pages */
  handleProductPages();
  /** Add Event Listener to handle Click of the button */
  (customButton as HTMLButtonElement)?.addEventListener('click', () => {
    console.info('user clicked chat chip');
    const isConversationBrowserClosed = sessionStorage.getItem('isConversationBrowserClosed');
    if (!isChatActive()) {
      if (isConversationBrowserClosed === 'true') {
        updateFloatingButtonText(t('ChatEnded'));
      } else {
        updateFloatingButtonText(t('ca-loading'));
      }
    }

    launchChat();
    const { finalContext: contextData } = context;
    trackEvent('Chat Initiated', {
      category: 'Global Chat',
      label: 'Chat help initiated - Chat Anywhere',
      eventDetail: `${contextData.pagePath.value || ''};Chat Initiate`,
      pageName: contextData.pageName.value || 'Others',
      pageSection: contextData.pageSection.value || 'Others',
      pageStage: contextData.pageStage.value || 'Others',
    });
    logNR('CA_HELP_BUTTON_CLICKED');
  });
  addSkipLinkBtn();
};
